// src/components/RejectionModal.js
import React, { useState, useEffect } from 'react';
import styles from '../styles/RejectionModal.module.css'; // We'll create this CSS module

const RejectionModal = ({ isOpen, onClose, onSubmit, taskName, isSubmitting }) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    // Clear reason when modal opens/closes
    useEffect(() => {
        if (!isOpen) {
            setReason('');
            setError('');
        }
    }, [isOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!reason.trim()) {
            setError('Rejection reason cannot be empty.');
            return;
        }
        setError('');
        onSubmit(reason.trim()); // Pass the reason to the parent handler
    };

    if (!isOpen) {
        return null; // Don't render anything if modal is closed
    }

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <h3 className={styles.modalTitle}>Reject Task Submission</h3>
                <p className={styles.modalTaskName}>Task: {taskName || 'Untitled Task'}</p>
                <form onSubmit={handleSubmit}>
                    <div className={styles.inputGroup}>
                        <label htmlFor="rejectionReason">Reason for Rejection:</label>
                        <textarea
                            id="rejectionReason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            rows="4"
                            placeholder="Provide clear feedback for the assignee..."
                            required
                            disabled={isSubmitting}
                            className={styles.reasonTextarea}
                        />
                        {error && <p className={styles.errorMessage}>{error}</p>}
                    </div>
                    <div className={styles.buttonGroup}>
                        <button
                            type="button"
                            onClick={onClose}
                            className={`${styles.modalButton} ${styles.cancelButton}`}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={`${styles.modalButton} ${styles.submitButton}`}
                            disabled={isSubmitting || !reason.trim()}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit Rejection'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RejectionModal;
